module.exports = __webpack_public_path__ + "static/media/headline_bkg_small.cd7ee1d0.jpg";